// src/legacy.ts
var CurrencyFormatter = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD"
});
var USCurrencyFormatter = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
  maximumFractionDigits: 2,
  minimumFractionDigits: 2
});
var NumberFormatter = new Intl.NumberFormat("en-US");
var PercentFormatter = new Intl.NumberFormat("en-US", {
  style: "percent"
});
var USDFormatter = (value) => {
  return CurrencyFormatter.format(value).replace(/^(\D+)/, "$1 ");
};

// src/formatter.ts
var LocaleMap = /* @__PURE__ */ new Map([["en", "en-US"]]);
var Formatter = class {
  constructor(locale) {
    this.locale = LocaleMap.get(locale) ?? locale;
  }
  /**
   * @param options Provides options to the Intl.NumberFormat
   * @description Builds a new Intl.NumberFormat instance with the given options.
   */
  build(options) {
    return new Intl.NumberFormat(this.locale, options ?? {});
  }
  /**
   * @param value The value to format. This can be a number, string, or bigint.
   * @param options Number format options
   */
  number(value, options) {
    return this.build(options).format(Number(value));
  }
  /**
   * @param value The value to format into a percentage. This can be a number, string, or bigint.
   * @param options Number format options
   */
  percent(value, options) {
    return this.build({
      ...options,
      style: "percent"
    }).format(Number(value));
  }
  currency(value, options = {}) {
    const { currency = "USD", ...rest } = options;
    return this.build({
      ...rest,
      style: "currency",
      currency
    }).format(Number(value));
  }
};

export { CurrencyFormatter, Formatter, NumberFormatter, PercentFormatter, USCurrencyFormatter, USDFormatter };
